"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledModalTitle = exports.TextLink = exports.Amount = exports.Payments = exports.Title = exports.AmountWrapper = exports.Row = exports.List = exports.ListAmount = exports.ListTitle = exports.ListTitleRow = exports.ModalHeaderWrapper = exports.ModalContent = void 0;
const header_with_sub_text_1 = require("@pulse-web-ui/header-with-sub-text");
const theme_1 = require("@pulse-web-ui/theme");
exports.ModalContent = theme_1.styled.div `
  ${theme_1.typography.regular16};
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;
exports.ModalHeaderWrapper = theme_1.styled.div `
  padding-right: 30px;
`;
exports.ListTitleRow = theme_1.styled.div `
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: end;
  margin-bottom: 12px;
`;
exports.ListTitle = theme_1.styled.div `
  ${theme_1.typography.medium16};
  text-align: left;
  line-height: 24px;
`;
exports.ListAmount = (0, theme_1.styled)(exports.ListTitle) `
  text-align: right;
`;
exports.List = theme_1.styled.ul `
  display: flex;
  flex-direction: column;
  padding-left: 0px;
`;
exports.Row = theme_1.styled.li `
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: start;
  padding: 4px 0px 4px 0px;
  margin-bottom: 2px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[30]};
`;
exports.AmountWrapper = theme_1.styled.div `
  display: flex;
  justify-content: space-between;
  gap: 24px;
  text-align: right;
`;
exports.Title = theme_1.styled.div `
  line-height: 24px;
  text-align: left;
`;
exports.Payments = (0, theme_1.styled)(exports.Title) `
  ${theme_1.typography.medium16};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: right;
`;
exports.Amount = (0, theme_1.styled)(exports.Title) `
  ${theme_1.typography.medium16};
  text-align: right;
  min-width: 70px;
`;
exports.TextLink = theme_1.styled.a `
  color: ${({ theme }) => theme.common?.a?.color
    ? theme.common.a.color
    : theme.colors.text.interactive};
  text-decoration: ${({ theme }) => theme.common?.a?.decoration ? theme.common.a.decoration : 'none'};

  &:hover {
    color: ${({ theme }) => theme.colors.text['interactive-clarified']};
  }
`;
exports.StyledModalTitle = (0, theme_1.styled)(header_with_sub_text_1.HeaderWithSubText) `
  ${theme_1.media.desktop} {
    white-space: break-spaces;
  }
`;
